import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function PopupImage({ handleViewClose, PopupImageOpen }) {
  return (
    <div>
      <BootstrapDialog
        onClose={handleViewClose}
        aria-labelledby="customized-dialog-title"
        open={PopupImageOpen}
      >
        <DialogContent dividers>
          <div
            style={{
              width: "500px",
              height: "200px",
              backgroundImage: `url(${PopupImageOpen})`,
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          />
          {/* <img 
          alt=""
          className="img-fluid"
          src={PopupImageOpen}/> */}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleViewClose}>
            cancel
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
